import useMods from '@hooks/useMods';

import PropTypes from 'prop-types';
import React from 'react';

const Section = ({ children, mods={}, mix={}, className: classNameTail='' }) => {
    const { className } = useMods(Section, { mix, mods });

    return (
        <section
            className={ className + (classNameTail ? ' ' + classNameTail : '') }
        >
            { children }
        </section>
    );
};

Section.displayName = 'Section';

Section.propTypes = {
    children: PropTypes.node,
    mix: PropTypes.object,
    mods: PropTypes.object
};

export default Section;
